// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f13f4580","703":"8ab95441"}[chunkId] + ".chunk.js";
};